<!-- Compiled at 2026-05-13T13:50:05.286Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: block" [class.fill]="true">
				<div style="display: flex; flex-direction: column; width: 100%" class="fill">
					<mat-toolbar color="primary" [style.flex]="'0 0 auto'">
						<button
							type="button"
							aria-label="Toggle sidenav"
							mat-icon-button
							(click)="toggle_sidebar_206()"
							*ngIf="isHandset$ | async"
						>
							<mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
						</button>
						<div
							class="layout-block fill"
							[style.align-items]="'inherit'"
							[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
							[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
							[style.gap]="'1em'"
						>
							<ng-container *ngIf="!screen.isForExternalUser"
								><button
									class="fill"
									style="margin-left: -12px"
									type="button"
									aria-label="Toggle sidenav"
									mat-icon-button
									(click)="toggle_sidebar_206()"
								>
									<mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
								</button>
							</ng-container>

							<Llama-MainLayoutHeader
								class="fill"
								[$formDirective]="$formDirective"
								[$disabled]="$disabled"
								[$ignoreValidations]="$ignoreValidations"
							>
							</Llama-MainLayoutHeader>
						</div>
					</mat-toolbar>

					<mat-sidenav-container [class]="'theme-lowgile'" [style.flex]="'1 1 auto'">
						<mat-sidenav
							style="width: 19em"
							[fixedInViewport]="false"
							[attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
							[mode]="(isHandset$ | async) ? 'over' : 'side'"
							[opened]="sidebar_206()"
						>
							<div
								class="layout-block vertical"
								style="height: 100%"
								[style.align-items]="'inherit'"
								[style.gap]="'0'"
							>
								<Llama-MainLayoutSidebar
									[$formDirective]="$formDirective"
									[$disabled]="$disabled"
									[$ignoreValidations]="$ignoreValidations"
								>
								</Llama-MainLayoutSidebar>
								<div
									class="layout-block"
									[style.flex]="'1 0 auto'"
									[style.align-items]="'inherit'"
									[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
									[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
									[style.gap]="'1em'"
								></div>
								<div
									class="layout-block"
									style="justify-content: center; margin-bottom: 1.5rem"
									[style.align-items]="'center'"
									[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
									[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
									[style.gap]="'1em'"
								>
									<span
										style="font-weight: bold"
										[innerHtml]="'powered by' | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span>
									<img
										style="height: 35px"
										[src]="'/studio/assets/logo.svg' | safeUrl"
									/>
								</div>
							</div>
						</mat-sidenav>

						<mat-sidenav-content>
							<h1
								style="padding: 1.5rem 1rem"
								[innerHtml]="screen.screenTitle | escapeHtml: 'none' | replaceNewlines: 'h1'"
							></h1>
							<ng-template
								[ngTemplateOutlet]="getContentTemplate('content')"
								[ngTemplateOutletContext]="{ $scope, $formDirective, $disabled }"
							></ng-template>
						</mat-sidenav-content>
					</mat-sidenav-container>
				</div>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
